import { ChangeDetectionStrategy, Component, Inject, OnInit, Renderer2, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FastCheckinPaymentDTO, FastCheckinType, ParkingPaymentClient } from 'src/app/base/models/models.swagger.generated';
import { AuthService } from 'src/app/base/services/auth.service';
import * as pages from 'src/app/core/routing/page-names';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  styleUrls: ['./payment-successful.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSuccessfulComponent implements OnInit {
  protected readonly hasPaymentIdent = signal(false);
  protected readonly isProcessingPaymentResult = signal(false);
  protected readonly hasPaymentProcessingError = signal(false);

  constructor(
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(ParkingPaymentClient) private parkingPaymentClient: ParkingPaymentClient,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'body-login');

    const paymentIdent = this.route.snapshot.paramMap.get('paymentIdent');
    if (!paymentIdent) {
      return;
    }

    this.hasPaymentIdent.set(true);
    this.isProcessingPaymentResult.set(true);

    this.parkingPaymentClient
      .handleFastCheckinPayment(new FastCheckinPaymentDTO({ paymentIdent }), this.authService.getAnonymousUserLanguage())
      .pipe(finalize(() => this.isProcessingPaymentResult.set(false)))
      .subscribe({
        next: result => {
          if (!result?.sessionIdent) {
            this.hasPaymentProcessingError.set(true);
            return;
          }

          if (result.fastCheckinType === FastCheckinType.FastCheckIn) {
            this.router.navigate([pages.fastCheckinPageName, result.sessionIdent]);
          } else if (result.fastCheckinType === FastCheckinType.PayTillNow) {
            this.router.navigate([pages.payTillNowPageName, result.sessionIdent]);
          }
        },
        error: () => {
          this.hasPaymentProcessingError.set(true);
        }
      });
  }

}
